import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PLayout from "./PLayout";
import { useApp } from "@/context/AppContext";
import { useAppUi } from "@/i18n/appUi";
import { getQuiz, submitQuiz } from "@/lib/api";

export default function QuizDetail() {
  const { id } = useParams();
  const { lang } = useApp();
  const t = useAppUi(lang);
  const [q, setQ] = useState(null);
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { getQuiz(id).then(setQ).catch(() => setQ(false)); }, [id]);

  const submit = async () => {
    setBusy(true);
    try {
      const r = await submitQuiz(id, answers);
      setResult(r.attempt);
      window.scrollTo(0, 0);
    } finally { setBusy(false); }
  };

  if (q === null) return <PLayout><div className="rbl-spinner" /></PLayout>;
  if (!q) return <PLayout><p>{t("qzNotFound")}</p></PLayout>;

  const isCorrect = (qq, optIndex) => result && String(qq.correct_answer).toLowerCase() === String(optIndex).toLowerCase();
  const chosen = (qq) => answers[qq.id];

  return (
    <PLayout>
      <Link to="/app/quizzes" className="rbl-back">{t("qzBack")}</Link>
      <h1 className="rbl-h1" style={{ fontSize: 32, marginTop: 14 }} data-testid="quiz-title">{q.title}</h1>
      {q.description && <p className="rbl-intro">{q.description}</p>}

      {result && (
        <div className="rbl-ok" data-testid="quiz-result" style={{ fontSize: 16 }}>
          <strong>{t("qzScore")}: {result.score}%</strong> ({result.auto_scored_correct}/{result.auto_scored_total} {t("qzAutoCorrect")})
        </div>
      )}

      <div className="rbl-quiz" style={{ marginTop: 12 }}>
        {(q.questions || []).map((qq, qi) => (
          <div className="rbl-q" key={qq.id}>
            <div className="rbl-q-text">{qi + 1}. {qq.text}</div>
            {qq.type === "multiple_choice" && (qq.options || []).map((opt, oi) => {
              let cls = "rbl-choice";
              if (result) { if (isCorrect(qq, oi)) cls += " correct"; else if (String(chosen(qq)) === String(oi)) cls += " wrong"; }
              else if (String(chosen(qq)) === String(oi)) cls += " sel";
              return <button key={oi} className={cls} disabled={!!result} data-testid={`quiz-${qq.id}-opt${oi}`}
                onClick={() => setAnswers((a) => ({ ...a, [qq.id]: String(oi) }))}>{opt}</button>;
            })}
            {qq.type === "true_false" && ["true", "false"].map((v) => {
              let cls = "rbl-choice";
              if (result) { if (isCorrect(qq, v)) cls += " correct"; else if (chosen(qq) === v) cls += " wrong"; }
              else if (chosen(qq) === v) cls += " sel";
              return <button key={v} className={cls} disabled={!!result} data-testid={`quiz-${qq.id}-${v}`}
                onClick={() => setAnswers((a) => ({ ...a, [qq.id]: v }))}>{v === "true" ? t("trUp") : t("trDown")}</button>;
            })}
            {qq.type === "open_text" && (
              <textarea className="rbl-input" disabled={!!result} value={answers[qq.id] || ""}
                onChange={(e) => setAnswers((a) => ({ ...a, [qq.id]: e.target.value }))} />
            )}
          </div>
        ))}
        {!result && (
          <button className="rbl-btn block" onClick={submit} disabled={busy} data-testid="quiz-submit">
            {busy ? t("qzScoring") : t("qzSubmit")}
          </button>
        )}
      </div>
    </PLayout>
  );
}
